// src/config/apiConfig.js
// const BASE_URL = 'https://farmology.ai';
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://farmology.ai"; // Fallback to localhost if not set
const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL || "https://farmology.ai"; // Fallback to localhost if not set
export default BASE_URL;
export { FRONTEND_BASE_URL };
